import { List, ListItem, ListItemButton, ListItemIcon, ListItemText} from '@mui/material'
import { useTranslation } from 'react-i18next'
import Delete from '@material-symbols/svg-600/outlined/delete.svg?react'
import { Link, useLocation } from 'react-router'
import { useMe } from '../hooks/useMe'
import { is_history_enabled } from '../utils/config'
import WipTooltip from './WipTooltip'

type Props = {
  is_mobile: boolean
  close: ()=> void
}
const GlobalPopMenuList: React.FC<Props> = ({is_mobile, close}) => {
  const {t} = useTranslation()
  const me = useMe()
  const location = useLocation()

  return <>
    <List>
      {is_history_enabled && me && <ListItem disablePadding>
        <ListItemButton component={Link} to='/history/worlds' onClick={close}>
          <ListItemIcon><span className='material-icons-outlined'>history</span></ListItemIcon>
          <ListItemText primary={t('history.title')}/>
        </ListItemButton>
      </ListItem>}
      {me && <ListItem disablePadding>
        <ListItemButton
          component={Link} to={`/user/${me.user_id}`} state={{from: location.pathname}}
          onClick={()=> { close() }}
        >
          <ListItemIcon>
            <span className='material-icons-outlined'>person</span>
          </ListItemIcon>
          <ListItemText primary={t('header.profile')}/>
        </ListItemButton>
      </ListItem>}
      {FEATURE_ADDRESS_BOOK && is_mobile && <ListItem disablePadding>
        <ListItemButton
          component={Link} to='/address_book' state={{from: location.pathname}}
          onClick={()=> { close() }}
        >
          <ListItemIcon>
            <span className='material-icons-outlined'>group</span>
          </ListItemIcon>
          <ListItemText primary={t('general.address_book')}/>
        </ListItemButton>
      </ListItem>}
      {FEATURE_TRASH && me && <ListItem disablePadding>
        <ListItemButton
          component={Link} to='/trash' state={{from: location.pathname}}
          onClick={()=> { close() }}
        >
          <ListItemIcon>
            <Delete className='md-24' fill='currentColor'/>
          </ListItemIcon>
          <ListItemText
            primary={t('feature.trash')}
          />
        </ListItemButton>
      </ListItem>}
      {is_mobile && is_history_enabled && me && (FEATURE_DM ? (
        <ListItem disablePadding>
          <ListItemButton component={Link} to='/dm' state={{from: location.pathname}} onClick={close}>
            <ListItemIcon><span className='material-icons-outlined'>mail</span></ListItemIcon>
            <ListItemText primary={t('feature.dm')}/>
          </ListItemButton>
        </ListItem>
      ) : (
        <WipTooltip>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon><span className='material-icons-outlined' style={{color: 'gray'}}>mail</span></ListItemIcon>
              <ListItemText primary={t('feature.dm')} slotProps={{primary: {color: 'gray'}}}/>
            </ListItemButton>
          </ListItem>
        </WipTooltip>
      ))}
      {FEATURE_PLAN && me && <ListItem disablePadding>
        <ListItemButton
          onClick={()=> { close() }}
          component={Link} to='/plan'
          state={{from: location.pathname}}
        >
          <ListItemIcon>
            <span className='material-icons-outlined'>shopping_cart</span>
          </ListItemIcon>
          <ListItemText primary={t('header.plan')}/>
        </ListItemButton>
      </ListItem>}
      {me && <ListItem disablePadding>
        <ListItemButton
          component={Link} to='/setting'
          state={{from: location.pathname}}
          onClick={()=> { close() }}
        >
          <ListItemIcon>
            <span className='material-icons-outlined'>settings</span>
          </ListItemIcon>
          <ListItemText primary={t('header.setting')}/>
        </ListItemButton>
      </ListItem>}
      <ListItem disablePadding>
        <ListItemButton
          component={Link} to='/help'
          state={{from: location.pathname}}
          onClick={()=> { close() }}
        >
          <ListItemIcon>
            <span className='material-icons-outlined'>help_outline</span>
          </ListItemIcon>
          <ListItemText primary={t('header.help')}/>
        </ListItemButton>
      </ListItem>
      <ListItem disablePadding>
        <ListItemButton
          component={Link} to='/about'
          state={{from: location.pathname}}
          onClick={()=> { close() }}
        >
          <ListItemIcon>
            <span className='material-icons-outlined'>info</span>
          </ListItemIcon>
          <ListItemText primary={t('header.about')}/>
        </ListItemButton>
      </ListItem>
    </List>
  </>
}
export default GlobalPopMenuList
